import { format, subMonths } from 'date-fns';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FlatList, View } from 'react-native';
import { ActivityIndicator, Text } from 'trpc-react-native-ui';
import config from '../../../config';
import I18n from '../../../lib/i18n';
import UsageListViewRow from '../UsageListViewRow/UsageListViewRow';

const styles = {
  activityIndicator: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  },
  container: {
    flex: 1,
  },
  descriptionContainer: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    marginHorizontal: 30,
  },
  description: {
    color: 'grey',
    fontSize: 16,
    textAlign: 'center',
  },
  separator: {
    backgroundColor: '#ddd',
    height: 1,
  },
};

class UsageDetail extends Component {
  componentDidMount() {
    const { beginDate, endDate } = this.getDateRange();
    this.props.fetchDetailedUsages(null, beginDate, endDate);
  }

  getDateRange() {
    const beginDate = format(subMonths(this.props.nextRenewalDate, 6), 'yyyyMMddhhmmss');
    const endDate = format(this.props.nextRenewalDate, 'yyyyMMddhhmmss');

    return {
      beginDate,
      endDate,
    };
  }

  renderItem = ({ item: rowData }) => (
    <UsageListViewRow
      amount={rowData.usageCharacteristics.BUCKET_CHARGE}
      from={rowData.usageCharacteristics.LOCALIZATION}
      phoneLine={rowData.usageCharacteristics.TRANSLATE_ADDRESS}
      quantity={rowData.usageCharacteristics.QUANTITY}
      timestamp={rowData.dateUsage}
      to={rowData.usageCharacteristics.COUNTRY_DESTINATION}
      type={rowData.usageCharacteristics.USAGE}
    />
  );

  render() {
    const { usages, isFetching } = this.props;
    return (
      <View style={styles.container}>
        {isFetching ? <ActivityIndicator style={styles.activityIndicator} /> : null}
        {!isFetching && !usages.length && config.showUsageGraph ? (
          <View style={styles.descriptionContainer}>
            <Text style={styles.description}>{I18n.t('internationalAndPremiumDescription')}</Text>
          </View>
        ) : null}
        {!isFetching && usages.length ? <FlatList data={usages} renderItem={this.renderItem} /> : null}
      </View>
    );
  }
}

UsageDetail.propTypes = {
  dataSource: PropTypes.object,
  fetchDetailedUsages: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  nextRenewalDate: PropTypes.number,
};

export default UsageDetail;
